/**
 * Navigation Configuration Types
 */

export interface NavItemConfig {
  id: string;
  to: string;
  label: string;
  iconName: string;
  visible: boolean;
  order: number;
}

export interface NavigationConfig {
  items: NavItemConfig[];
}

export const DEFAULT_NAV_ITEMS: Omit<NavItemConfig, 'visible' | 'order'>[] = [
  {
    id: 'dashboard',
    to: '/',
    label: 'Dashboard',
    iconName: 'LayoutDashboard',
  },
  {
    id: 'patients',
    to: '/patients',
    label: 'Patients',
    iconName: 'Users',
  },
  {
    id: 'calendar',
    to: '/calendar',
    label: 'Calendar',
    iconName: 'Calendar',
  },
  {
    id: 'reports',
    to: '/reports',
    label: 'Reports',
    iconName: 'BarChart3',
  },
  {
    id: 'messages',
    to: '/messages',
    label: 'Messages',
    iconName: 'MessageSquare',
  },
  {
    id: 'administration',
    to: '/administration',
    label: 'Administration',
    iconName: 'Settings',
  },
];

export const DEFAULT_NAVIGATION_CONFIG: NavigationConfig = {
  items: DEFAULT_NAV_ITEMS.map((item, index) => ({
    ...item,
    visible: true,
    order: index,
  })),
};

